export default "__VITE_ASSET__B60xcGt7__"